import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { OPEN_REMIND, RemindForm } from "./RemindForm";
import { LAUNCH_LABEL, useLocalLaunch } from "@/lib/launch";

export const RemindDialog = () => {
  const [open, setOpen] = useState(false);
  const local = useLocalLaunch();
  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener(OPEN_REMIND, on);
    return () => window.removeEventListener(OPEN_REMIND, on);
  }, []);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="remind-dialog" className="bg-[#1B1530] text-white border-0 rounded-[28px] max-w-md">
        <p className="eyebrow text-[#FFB21A]">{LAUNCH_LABEL}{local && <span data-testid="remind-dialog-local-time" className="block mt-1 normal-case tracking-normal text-zinc-300">{local}</span>}</p>
        <DialogTitle className="font-display text-4xl leading-none">Don't miss the drop.</DialogTitle>
        <DialogDescription className="text-white/75">We'll send one text the second the bears go live. The first 5 orders get a free exclusive shirt.</DialogDescription>
        <RemindForm dark id="remind-dialog" />
      </DialogContent>
    </Dialog>
  );
};
